import axiosInstance from "@/api/axiosInstance";
import { DuplicateEventSessionResponse } from "./types";

export const duplicateEventSession = async (
  uuid: string,
): Promise<DuplicateEventSessionResponse> => {
  const response = await axiosInstance.post<DuplicateEventSessionResponse>(
    `/api/private/event-sessions/${uuid}/duplicate`,
  );

  return response.data;
};
